import React from 'react';
import * as S from './style';

function StatusBadge({ color, text }) {
  return <S.Badge color={color}>{text}</S.Badge>;
}

export default StatusBadge;
